export default class ServerValidationError extends Error {
  constructor (data) {
    super(data.message)
    this.name = 'Server Validation Error'
    this.errorList = data.errors
  }
}
